var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-icon",style:({ width: _vm.width, height: _vm.height })},[(_vm.is('image'))?_c('img',_vm._b({},'img',_vm.config,false)):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }